import { Link } from "react-router-dom";
import { allVideos, categoryList } from "@/lib/videoData";
import { categoryCovers } from "@/mocks/site";

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1360px] px-4 pt-10 md:px-8 md:pt-14">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-[22px]">
            快速进入分类
          </h2>
          <p className="mt-1 text-xs text-foreground-600 md:text-[13px]">
            三大内容板块，覆盖电影、剧集与综艺的完整片库
          </p>
        </div>
        <Link
          to="/search"
          className="flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium text-foreground-700 transition-colors hover:bg-background-200/60 hover:text-primary-700"
        >
          搜索全部片库
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categoryList.map((category) => {
          const count = allVideos.filter((item) => item.category === category.slug).length;
          return (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative block h-[168px] cursor-pointer overflow-hidden rounded-lg md:h-[190px]"
            >
              <img
                src={categoryCovers[category.slug]}
                alt={`${category.name}分类封面`}
                title={`${category.name} - 糖豆视频精选影视分类`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/70 to-primary-950/20" />
              <div className="absolute inset-0 flex flex-col justify-between p-5">
                <div className="flex items-start justify-between">
                  <span className="text-[10px] font-bold tracking-[0.24em] text-accent-400">{category.en}</span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border border-background-50/25 text-background-100 transition-colors group-hover:border-accent-400 group-hover:bg-accent-500 group-hover:text-foreground-950">
                    <i className="ri-arrow-right-up-line text-base" />
                  </span>
                </div>
                <div>
                  <h3 className="font-heading text-2xl font-bold text-background-50">{category.name}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-background-300/90">{category.short}</p>
                  <p className="mt-2 flex items-center gap-1 text-[11px] font-medium text-accent-300">
                    <i className="ri-play-list-2-line text-sm" />
                    已收录 {count} 部内容
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}